import type {
  GetUploadsForDocumentQuery,
  GetUploadsForDocumentQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_UPLOADS_FOR_DOCUMENT: TypedDocumentNode<
  GetUploadsForDocumentQuery,
  GetUploadsForDocumentQueryVariables
> = gql`
  query GetUploadsForDocument($documentId: ID!, $limit: Int) {
    uploadsForDocument(documentId: $documentId, limit: $limit) {
      id
      resourceId
      filename
      createdAt
      documentId
      documentPath
      url
      isEncrypted
    }
  }
`;
